import { Box, Chip, Tooltip } from '@mui/material';

/**
 * The admin level of a role assignment (identity, GET me/assignments `level`
 * per item; admin-levels-2026-10-15.md section 7). Only "super_admin" gets a
 * badge in the role switcher (Application Admin role + the platform-owner
 * flag, in the Internal organisation); the other levels show nothing.
 */
export const isSuperAdminLevel = (level: unknown): boolean => level === 'super_admin';

export function SuperAdminBadge({
  level,
  testId,
  dark = false,
  compact = false,
}: {
  level: unknown;
  testId?: string;
  /** on the dark sidebar background */
  dark?: boolean;
  /** the collapsed sidebar (65px): a dot with a tooltip, the chip would be cut off */
  compact?: boolean;
}) {
  if (!isSuperAdminLevel(level)) return null;
  if (compact)
    return (
      <Tooltip title='Super Admin' placement='right'>
        <Box
          component='span'
          role='img'
          aria-label='Super Admin'
          data-testid={testId}
          sx={{
            display: 'inline-block',
            width: 10,
            height: 10,
            borderRadius: '50%',
            bgcolor: 'warning.main',
            border: '2px solid',
            borderColor: 'primary.main',
          }}
        />
      </Tooltip>
    );
  return (
    <Chip
      size='small'
      color='warning'
      label='Super Admin'
      data-testid={testId}
      sx={{
        height: 20,
        fontSize: '11px',
        fontWeight: 700,
        ...(dark ? { ml: 1 } : {}),
      }}
    />
  );
}
